<template>
  <div class="right_body action_body">
    <span class="btn right_sub_btn save_btn" @click.stop="onSubmitSave" >提交数据</span>
    <div class="active_rumb"><span class="txt">采购订单_收货</span></div>

    <div class="coll header_box">
			<h2 class="title"><span>抬头信息</span></h2>
		  <PurchOrderReapHeader ref="orderreapheader" @onOrderDetail="onOrderDetail"></PurchOrderReapHeader>
		</div>   

    <div class="coll list_content">
			<h2 class="title"><span>数据明细</span></h2>		
      <PurchOrderReapBody  ref="orderReapBody" ></PurchOrderReapBody> 
		</div>

  </div>
</template>

<script>
import PurchOrderReapHeader from "./components/reap/PurchOrderReapHeader.vue";
import PurchOrderReapBody from "./components/reap/PurchOrderReapBody.vue";
import {purchaseOrderApi} from 'api/PurchaseMngApi.js';
export default {
  components:{
    PurchOrderReapHeader,
    PurchOrderReapBody
  },
  methods:{
    onOrderDetail(details){
      if(details){
        this.$refs.orderReapBody.detailData=details;
      }else{
        this.$refs.orderReapBody.detailData=[];
      }      
	},
	
    /**
		 * 提交保存
		 */
		async onSubmitSave(){
			// debugger;
			this.$refs.orderReapBody.onSubmitSaves()
			let vm=this,order;
      		order=vm.$refs.orderreapheader.headerData;
			order.details=vm.$refs.orderReapBody.PurchOrderList;
			console.log(order.details.length)
			if(order.details.length == 0){ 
				this.$message.error('请勾选需要提交的数据明细！');
				return false;
			}
			if(!order.companyName){ 
				this.$message.error('请选择公司');
				return false;
			}
			if(!order.supplierName){ 
				this.$message.error('请选择供应商');
				return false;
			}
			let isTrue = true;
			order.details.forEach((item)=>{
				if(!item.currentDeliveryNum){ 
					this.$message.error('请选择收货数量');
					isTrue = false;
					return false;
				}
			})
			if(!isTrue) return false;
            console.log(JSON.stringify(order));
			let res = await this.$post(purchaseOrderApi.receiptOrderUrl,order);
			if(res.type=='F'){
				this.$message.error(res.msg); 
				return;
			}
			this.$confirm('采购订单号 '+res.data.purchaseOrderNo+' 收货成功;是否继续？', '提示', {
				confirmButtonText: '继续',
				cancelButtonText: '退出',
				type: 'success'
			}).then(() => {
				vm.clearOrder();
				vm.$router.push({name:'business-purchaseorder-purchaseordernew'});
			}).catch(() => {
				vm.$router.push({name:'business-purchaseorder-purchaseordersearch'});
				vm.clearOrder();
				vm.close({tagName:"business-purchaseorder-purchaseordernew"});
			});
		}
    
  }

}
</script>

<style scoped>

</style>